import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import I18n from "./locale/I18n";
import { makeStyles } from "@material-ui/core";
import Part from "./Part";
import React from "react";

const useStyles = makeStyles(theme => ({
    member: {
        marginBottom: theme.spacing(2)
    },
    name: {
        color: theme.palette.grey[800],
        fontSize: "1.2rem"
    },
    function: {
        color: theme.palette.grey[600],
        fontSize: "1rem"
    },
    title: {
        color: theme.palette.primary.main, //theme.palette.grey[600],
        fontSize: "1.2rem",
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1.5)
    }
}));

const MembersList = props => {
    const { classes, members } = props;
    return (
        <>
            {members.map(member => {
                return (
                    <div key={member.name} className={classes.member}>
                        <div className={classes.name}>{member.name}</div>
                        <div className={classes.function}>
                            {member.description}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

const ListTitle = props => {
    const { classes, title } = props;
    return <div className={classes.title}>{title}</div>;
};

const Team = props => {
    const eduMembers = [
        {
            name: "Dr. Manfred Künzel",
            description:
                "Consultant. Explores educational environments and creates generic solutions."
        },
        {
            name: "Beat Bänziger",
            description: "Producer, customer support."
        },
        {
            name: "Roman Bänziger",
            description: "Technical communication."
        },
        {
            name: "Dr. Jan Peschka",
            description: "Data protection officer."
        }
    ];
    const devMembers = [
        {
            name: "Dr. Guillaume Zufferey",
            description:
                "Owner. Crafts learning platforms, bringing together leading-edge web technologies."
        },
        //{
        //    name: "Jorge Alves",
        //    description: "Senior developer."
        //},
        {
            name: "Huong-Ly Bonnard",
            description: "Senior developer."
        },
        {
            name: "Dr. Quentin Bonnard",
            description: "Senior developer and DevOps manager."
        },
        {
            name: "Mila Kjoseva",
            description: "Full stack developer."
        },
        {
            name: "Susen Thonig",
            description: "IT specialist"
        }
        //{
        //    name: "Dimitar Bajraktarov",
        //    description: "Full stack developer."
        //}
    ];
    const classes = useStyles();
    return (
        <>
            <Part alternateColor title={<I18n label="Team" />}>
                <Card>
                    <CardContent>
                        <Grid container spacing={6}>
                            <Grid item xs={12} sm={6}>
                                <ListTitle
                                    title={<I18n label="Team_Dev" />}
                                    classes={classes}
                                />
                                <MembersList
                                    classes={classes}
                                    members={devMembers}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <ListTitle
                                    title={<I18n label="Team_Consulting" />}
                                    classes={classes}
                                />
                                <MembersList
                                    classes={classes}
                                    members={eduMembers}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Part>
        </>
    );
};

export default Team;
